import OwnershipCertificates from './OwnershipCertificates'

export default OwnershipCertificates
